import React from 'react';
import { MdIosShare, MdMail } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';

type GuestActionsProps = {
  onClickViewContactsModal: () => void;
  onClickViewShareOptions: () => void;
  canShare: boolean;
  isLoggedIn: boolean;
};

const GuestActions: React.FC<GuestActionsProps> = ({
  onClickViewContactsModal,
  onClickViewShareOptions,
  canShare,
  isLoggedIn
}) => (
  <div className="flex items-center justify-between flex-1 gap-5">
    {canShare && (
      <Button
        type={ButtonType.Inverted}
        onClick={onClickViewShareOptions}
        icon={<MdIosShare size={20} />}
      >
        Share event
      </Button>
    )}
    {isLoggedIn && (
      <Button
        type={ButtonType.Inverted}
        icon={<MdMail size={20} />}
        onClick={onClickViewContactsModal}
        testId="button-contact-host"
      >
        Contact host
      </Button>
    )}
  </div>
);

export default GuestActions;
